export const round = (num: number, accuracy: number): number => {
    let p = Math.pow(10, accuracy)
    return Math.round((num + Number.EPSILON) * p) / p
}